import axios from "axios";
import { Base_URL } from "../url";

export const saveStoreDetails = async (storeData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/StoreMaster/StoreMaster?UserName=${userId}`,
      storeData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving store details!";
  }
};

export const getOfficeOptions = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData`);
    return response.data.map(office => ({
      officeCode: office.officeCode,
      officeName: office.officeName
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching office options!";
  }
};